module.exports = __webpack_public_path__ + "img/contact3.aa8fcd6a.png";